import React from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Constants
import { FirstTimeMeetingModeIntroData } from './FirstTimeMeetingModeIntroData.constants';

// Components
import NewFeatureCarouselModal from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal';

const FirstTimeMeetingModeIntro = () => {
  const [isOpen, toggleIsOpen] = useToggle(true);

  return <NewFeatureCarouselModal isOpen={isOpen} toggleIsOpen={toggleIsOpen} data={FirstTimeMeetingModeIntroData} />;
};

export default FirstTimeMeetingModeIntro;
